<template>
  <AnalyticsWidget
    title="Despatch Summary"
    subTitle="Despatch performance based on despatch tasks today"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Days Average"
              :value="summaryData.totalDaysBehindAvg">
              {{formatDecimal(summaryData.totalDaysBehindAvg)}}
              <template v-slot:info>Average days {{summaryData.totalDaysBehindAvg > 0 ? 'behind' : 'ahead of'}} despatch due date</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Overdue Panels Pending Production"
              :value="summaryData.totalPanelsPendingProduction">
              {{formatInteger(summaryData.totalPanelsPendingProduction)}}
              <template v-slot:info>Overdue or due today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Panels Pending Despatch"
              :value="summaryData.totalPanelsPendingDespatch">
              {{formatInteger(summaryData.totalPanelsPendingDespatch)}}
              <template v-slot:info>Overdue or due today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Panels Despatched"
              :value="summaryData.totalPanelsCompletedDespatch">
              {{formatInteger(summaryData.totalPanelsCompletedDespatch)}}
              <template v-slot:info>Panels despatched today</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

export default {
  name: 'TaskSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
  },
  data() {
    return {
      loading: true,
      summaryData: {},
    }
  },
  mounted() {
    this.loading = true
    this.requestData()
  },
  methods: {
    requestData() {
      var filterData = {
        startDate: moment().local().startOf('day').toDate().toISOString(),
        endDate: moment().local().endOf('day').toDate().toISOString(),
        includePanels: true
      }

      this.$apiService.analyticsService.getProductionDespatchSummary(filterData)
      .then(response => {
        this.summaryData = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    
  }
}
</script>